import React, { useEffect, useRef, useState } from "react";
import axios from "../../API/axios";
import { useTranslation } from "react-i18next";
const EditComment = ({
  isEditing,
  editedComment,
  handleCommentChange,
  handleSave,
  setIsEditing,
  dynamicValues,
  setEditedDynamicValue,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  console.log("dynamicValues prop", dynamicValues);
  const { t } = useTranslation();
  const [content, setContent] = useState();
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [query, setQuery] = useState(""); // Store the full query
  const editorRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const [isDynamicValueChange, setIsDynamicValueChange] = useState(false);
  const [oldPostInputValue, setOldPostInputValue] = useState();
  const [oldDynamicValue, setOldDynamicValue] = useState();
  const [count, setCount] = useState(0);
  const [SearchText, setSearchText] = useState("");
  const [initialValues, setInitialValues] = useState("");
  const [saveDisabled, setSaveDisabled] = useState(false);
    const language = localStorage.getItem("Lang");

  //DS
  const [selectedIndex, setSelectedIndex] = useState(0);
  const suggestionListRef = useRef(null);
  const itemRefs = useRef([]);
  console.log("content", content);
  console.log("postInputValue", postInputValue);
  console.log("postDynamicValues", postDynamicValues);

  const entityCacheRef = useRef({}); // 🔁 Cache to avoid duplicate API calls
  const debounceRef = useRef(null);
  useEffect(() => {
    if (count === 0) {
      setOldPostInputValue(editedComment);
      setOldDynamicValue(dynamicValues);
    }
  }, [count]);

  useEffect(() => {
    if (content === initialValues) {
      setSaveDisabled(true);
    } else {
      setSaveDisabled(false);
    }
  }, [content]);

  const normalizeDynamicValues = (dVals) => {
    console.log("dVals", dVals);
    return (
      dVals?.map((item) => ({
        dVno: item.dVno,
        displayName: item.displayName || item.display, // ✅ fallback
        type: item.type,
        entityID: item.entity || item.entityID,
      })) || []
    );
  };

  useEffect(() => {
    // setContent(editedComment)
    console.log("editedComment11", editedComment);
    console.log("editedComment22", dynamicValues);
    setCount(1);
    let updatedDynamicValues = isDynamicValueChange
      ? postDynamicValues
      : dynamicValues;
    // const parsed = parseComment(editedComment, updatedDynamicValues);
    const parsed = parseComment(
      editedComment,
      normalizeDynamicValues(dynamicValues, updatedDynamicValues)
    );
    console.log("parsed", parsed);
    setPostInputValue(editedComment);
    setContent(parsed);
    setInitialValues(parsed);
  }, []);

  const handleSaveComment = () => {
    try {
      // Flush any pending debounce so Save uses the latest typed text
      if (debounceRef.current) clearTimeout(debounceRef.current);

      let updatedDynamicValues = isDynamicValueChange
        ? postDynamicValues
        : (postDynamicValues?.length ? postDynamicValues : dynamicValues);

      const latestPostInputValue = content
        ? updatePostInputValueWithDynamicValues(
            content,
            updatedDynamicValues || []
          )
        : postInputValue;

      setPostInputValue(latestPostInputValue);
      handleCommentChange(latestPostInputValue, updatedDynamicValues);
      setEditedDynamicValue(updatedDynamicValues);
      // Pass text directly — parent setState would still be stale if we only called handleSave()
      handleSave(latestPostInputValue, updatedDynamicValues);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let updatedDynamicValues = isDynamicValueChange
      ? postDynamicValues
      : dynamicValues;
    console.log("updatedDynamicValues useEffect11", updatedDynamicValues);
    handleCommentChange(postInputValue, updatedDynamicValues);
    setEditedDynamicValue(postDynamicValues);
  }, [postInputValue, postDynamicValues]);

  const createPlaceholderMap = (dynamicValues) => {
    console.log("dynamicValues+++", dynamicValues);
    const map = {};

    dynamicValues?.forEach(({ dVno, displayName, type }) => {
      if (type === "UserMention") {
        map[dVno] = `@${displayName}`;
      } else if (type === "CompanyMention") {
        map[dVno] = `@${displayName}`;
      } else if (type === "Hashtag") {
        map[dVno] = `#${displayName}`;
      } else {
        map[dVno] = displayName; // fallback
      }
    });
    return map;
  };

  // 2. Parse and replace comment placeholders
  const parseComment = (apiComment, dynamicValues) => {
    console.log("apiComment", apiComment);
    console.log("dynamicValuesaa", dynamicValues);
    if (!apiComment || !dynamicValues?.length) return apiComment;
    const placeholderMap = createPlaceholderMap(dynamicValues);

    let parsedText = apiComment;

    Object.keys(placeholderMap).forEach((key) => {
      const regex = new RegExp(`\\{${key}\\}`, "g");
      parsedText = parsedText?.replace(regex, placeholderMap[key]);
    });

    // Strip HTML tags
    parsedText = parsedText?.replace(/<[^>]*>/g, "");

    return parsedText?.trim();
  };

  // 3. Parse only once when editing starts
  // useEffect(() => {
  //   console.log("inside useffect postInputValue", postInputValue);
  //   console.log("inside useffect postDynamicValue", postDynamicValues);
  //   if (isEditing && content?.includes("{")) {
  //     let updatedDynamicValues = isDynamicValueChange
  //       ? postDynamicValues
  //       : dynamicValues;
  //       console.log("updatedDynamicValues useEffect", updatedDynamicValues);
  //     const parsed = parseComment(content, updatedDynamicValues);

  //     setContent(parsed);
  //   } else {
  //     if (content !== "" && content !== undefined && content.length > 0) {
  //       setContent(content);
  //     }
  //   }
  // }, [isEditing, content, dynamicValues]);

  // const handleChange = (e) => {
  //   const value = e.target.value;
  //   const caret = e.target.selectionStart;

  //   setContent(value);
  //   setCursorPosition(caret);
  //   detectTrigger(value, caret);

  //   const seen = new Set();
  //   const merged = [...(postDynamicValues || []), ...(oldDynamicValue || [])];

  //   const mentionMatches = [...value.matchAll(/@\w[\w\s]*/g)].map((m) =>
  //     m[0].trim()
  //   );
  //   // const hashtagMatches = [...value.matchAll(/#\w[\w\d]*/g)].map(h => h[0].trim());
  //   // const hashtagMatches = [...value.matchAll(/#{1,2}\s*\w+/g)].map(h => h[0].trim()); // working for 2 hashtag
  //   const hashtagMatches = [...value.matchAll(/#+\s*\w+/g)].map((h) =>
  //     h[0].trim()
  //   );

  //   const allEntities = [...mentionMatches, ...hashtagMatches];

  //   const updatedDynamicValues = allEntities
  //     .map((entity, index) => {
  //       const isMention = entity.startsWith("@");
  //       const type = isMention ? "UserMention" : "Hashtag";
  //       const displayName = entity.slice(1);

  //       const key = `${type}_${displayName}`;
  //       if (seen.has(key)) return null;
  //       seen.add(key);

  //       // Check if already exists
  //       // const existing =
  //       //     postDynamicValues.find(d => d.displayName === displayName && d.type === type && d.entity === entity) ||
  //       //     (oldDynamicValue || []).find(d => d.displayName === displayName && d.type === type && d.entity === entity);
  //       const existing =
  //         postDynamicValues.find(
  //           (d) =>
  //             ("displayName" in d ? d.displayName : d.display)?.trim() ===
  //               displayName.trim() && d.type === type
  //         ) ||
  //         (oldDynamicValue || []).find(
  //           (d) =>
  //             ("displayName" in d ? d.displayName : d.display)?.trim() ===
  //               displayName.trim() && d.type === type
  //         );

  //       return {
  //         ...(existing || {}),
  //         type,
  //         displayName,
  //         entity: isMention
  //           ? existing?.entity || existing?.entityID || null
  //           : displayName, // fallback entity
  //         dVno: index + 1,
  //       };
  //     })
  //     .filter(Boolean);

  //   setPostDynamicValues(updatedDynamicValues);

  //   const updatedPostInputValue = updatePostInputValueWithDynamicValues(
  //     value,
  //     updatedDynamicValues
  //   );
  //   setPostInputValue(updatedPostInputValue);
  // };

  const callFetchSuggestionDataFunc = async (type, searchText) => {
    console.log("type, searchText", type, searchText);
    const results = await getSuggestionData(type, searchText);
    if (results) {
      return results
    } else {
      return [];
    }
  }

  const handleChange = (e) => {
    console.log("handleChange e", e);
    const value = e.target.value;
    const caret = e.target.selectionStart;
    console.log("value, caret", value, caret);
    setContent(value);
    setCursorPosition(caret);
    detectTrigger(value, caret);
  };

  useEffect(() => {
    if (!content) return;

    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      const processDynamicValues = async () => {
        const value = content;
        const seen = new Set();
        // const mentionMatches = [...value.matchAll(/@\w[\w\s]*/g)].map(m => m[0].trim());
        // const hashtagMatches = [...value.matchAll(/#+\s*\w+/g)].map(h => h[0].trim());
        const mentionMatches = [...value.matchAll(/@\w+/g)].map(m => m[0].trim());
        const hashtagMatches = [...value.matchAll(/#\w+/g)].map(h => h[0].trim());
        const allEntities = [...mentionMatches, ...hashtagMatches];
        //==========dhurve code======
        // const updatedDynamicValues = await Promise.all(
        //   allEntities.map(async (entity, index) => {
        //     const isMention = entity.startsWith("@");
        //     const type = isMention === "UserMention"  ? "UserMention" : "Hashtag";
        //     const displayName = entity.slice(1).trim();
        //     const key = `${type}_${displayName}`;

        //     if (seen.has(key) || !displayName) return null;
        //     seen.add(key);

        //     let existing =
        //       postDynamicValues.find(d =>
        //         (('displayName' in d ? d.displayName : d.display)?.trim() === displayName && d.type === type)
        //       ) ||
        //       (oldDynamicValue || []).find(d =>
        //         (('displayName' in d ? d.displayName : d.display)?.trim() === displayName && d.type === type)
        //       );

        //     // Check cache or fetch new
        //     if (!existing || existing.entity === null) {
        //       if (entityCacheRef.current[key]) {
        //         existing = entityCacheRef.current[key];
        //       } else {
        //         existing = await callFetchSuggestionDataFunc(isMention === "UserMention"? "@" : "#", displayName);
        //         if (existing && typeof existing === "object" && existing["0"]) {
        //           existing = existing["0"];
        //         }
        //         entityCacheRef.current[key] = existing;
        //       }
        //     }

        //     return {
        //       ...(existing || {}),
        //       type,
        //       displayName,
        //       entity: isMention === "UserMention"
        //         ? existing?.entity || existing?.entityID || existing?.userUid || null
        //         : displayName,
        //       dVno: index + 1
        //     };
        //   })
        // );
        //=========================Tamim old code=======================\\

        // const updatedDynamicValues = await Promise.all(
        //   allEntities.map(async (entity, index) => {
        //     const isMention = entity.startsWith("@");
        //     let type = "Hashtag";
        //     let displayName = entity.slice(1).trim();

        //     if (isMention) {
        //       // 🟢 Fix: UserMention vs CompanyMention check
        //       let existingEntity =
        //         postDynamicValues.find(d =>
        //           (d.displayName?.trim() === displayName && (d.type === "UserMention" || d.type === "CompanyMention"))
        //         ) ||
        //         (oldDynamicValue || []).find(d =>
        //           (d.displayName?.trim() === displayName && (d.type === "UserMention" || d.type === "CompanyMention"))
        //         );
        //       console.log("existingEntity", entity, existingEntity);
        //       if (!existingEntity) {
        //         let result;
        //         if (entityCacheRef.current[displayName]) {
        //           result = entityCacheRef.current[displayName];
        //         } else {
        //           result = await callFetchSuggestionDataFunc("@", displayName);
        //           if (result && typeof result === "object" && result["0"]) {
        //             result = result["0"];
        //           }
        //           entityCacheRef.current[displayName] = result;
        //         }
        //         existingEntity = result;
        //       }

        //       //  type = existingEntity?.type === "CompanyMention" ? "CompanyMention" : "UserMention";
        //       if (existingEntity?.entityType === "CompanyMention") {
        //         type = "CompanyMention";
        //       } else if (existingEntity?.entityType === "UserMention") {
        //         type = "UserMention";
        //       } else {
        //         type = "UserMention"; // fallback, agar API se type missing ho
        //       }

        //       return {
        //         type,
        //         dVno: index + 1,
        //         displayName,
        //         entity: existingEntity?.userUid || existingEntity?.entityID || existingEntity?.entity || null,
        //       };
        //     } else {
        //       // Hashtag logic
        //       let existingHash =
        //         postDynamicValues.find(d => d.displayName?.trim() === displayName && d.type === "Hashtag") ||
        //         (oldDynamicValue || []).find(d => d.displayName?.trim() === displayName && d.type === "Hashtag");

        //       if (!existingHash) {
        //         let result;
        //         if (entityCacheRef.current[displayName]) {
        //           result = entityCacheRef.current[displayName];
        //         } else {
        //           result = await callFetchSuggestionDataFunc("#", displayName);
        //           if (result && typeof result === "object" && result["0"]) {
        //             result = result["0"];
        //           }
        //           entityCacheRef.current[displayName] = result;
        //         }
        //         existingHash = result;
        //       }

        //       return {
        //         type: "Hashtag",
        //         dVno: index + 1,
        //         displayName,
        //         entityID: existingHash?.entityID,
        //         entity: displayName,
        //       };
        //     }
        //   })
        // );

        //=========================Tamim new code=======================\\
        const updatedDynamicValues = await Promise.all(
          allEntities.map(async (entity, index) => {
            const isMention = entity.startsWith("@");
            const displayName = entity.slice(1).trim();

            let type = "Hashtag";
            const key = `${displayName}`;

            if (isMention) {
              let existing =
                postDynamicValues.find(
                  (d) =>
                    d.displayName?.trim() === displayName &&
                    (d.type === "UserMention" || d.type === "CompanyMention")
                ) ||
                (oldDynamicValue || []).find(
                  (d) =>
                    d.displayName?.trim() === displayName &&
                    (d.type === "UserMention" || d.type === "CompanyMention")
                );

              // 🔹 If not found, fetch from API/cache
              if (!existing || existing.entity === null) {
                if (entityCacheRef.current[key]) {
                  existing = entityCacheRef.current[key];
                } else {
                  let result = await callFetchSuggestionDataFunc("@", displayName);
                  if (result && typeof result === "object" && result["0"]) {
                    result = result["0"];
                  }
                  entityCacheRef.current[key] = result;
                  existing = result;
                }
              }

              // 🔹 Decide type based on entityType
              if (existing?.entityType === "CompanyMention") {
                type = "CompanyMention";
              } else if (existing?.entityType === "UserMention") {
                type = "UserMention";
              } else {
                type = "UserMention"; // fallback
              }

              return {
                ...(existing || {}),
                type,
                displayName,
                dVno: index + 1,
                entity:
                  existing?.entity ||
                  existing?.entityID ||
                  existing?.userUid ||
                  null,
              };
            } else {
              // 🔹 Hashtag case
              let existing =
                postDynamicValues.find(
                  (d) => d.displayName?.trim() === displayName && d.type === "Hashtag"
                ) ||
                (oldDynamicValue || []).find(
                  (d) => d.displayName?.trim() === displayName && d.type === "Hashtag"
                );

              if (!existing) {
                if (entityCacheRef.current[key]) {
                  existing = entityCacheRef.current[key];
                } else {
                  let result = await callFetchSuggestionDataFunc("#", displayName);
                  if (result && typeof result === "object" && result["0"]) {
                    result = result["0"];
                  }
                  entityCacheRef.current[key] = result;
                  existing = result;
                }
              }

              return {
                ...(existing || {}),
                type: "Hashtag",
                displayName,
                dVno: index + 1,
                entityID: existing?.entityID,
                entity: displayName,
              };
            }
          })
        );

        const filtered = updatedDynamicValues.filter(Boolean);
        setPostDynamicValues(filtered);
        const updatedPostInputValue = updatePostInputValueWithDynamicValues(value, filtered);
        setPostInputValue(updatedPostInputValue);
      };

      processDynamicValues();
    }, 500); // debounce delay

    return () => clearTimeout(debounceRef.current);
  }, [content]);

  const getSuggestionData = async (type, searchText) => {
    try {
      const data = {
        deviceType: "Web",
        sessionId: sessionId,
              langKey: language === "en" ? "" : language,

      };
      let results = [];

      if (type === "@") {
        const res = await axios.post(`General/MentionTagDDL?Search=${searchText}`, data);
        results = res.data.responseData || [];
      } else if (type === "#") {
        const res = await axios.post(`General/HashtagDDL?SearchHashtag=${searchText}`, data);
        results = res.data.responseData || [];
      }
      return results;
    } catch (error) {
      console.log(error);
    }
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    console.log("rawContent", rawContent, dynamicValues);
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, displayName }) => {
      const prefix = (type === "UserMention" || type === "CompanyMention") ? "@" : "#";
      const fullMention = `${prefix}${displayName}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q);
    } else {
      // if (match[1] === "#") {
      //     setShowSuggestions(true);
      // } else {
      //     setShowSuggestions(false);
      // }
      setSearchText("");
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
            langKey: language === "en" ? "" : language,

    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(
          `General/MentionTagDDL?Search=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(
          `General/HashtagDDL?SearchHashtag=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(true);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  useEffect(() => {
    const textarea = document.getElementById("commentTextArea");
    if (textarea) {
      textarea.setSelectionRange(cursorPosition, cursorPosition);
      textarea.focus();
    }
  }, [cursorPosition]);

  const insertMention = (suggestion, userUid, entityType) => {
    console.log("Inserting mention:", suggestion, userUid, entityType);
    const input = editorRef.current;
    if (!input) return;

    //DS - code change
    setIsDynamicValueChange(true);

    input.focus();

    const cursorPos = input.selectionStart;
    const textBeforeCursor = input.value.slice(0, cursorPos);
    const textAfterCursor = input.value.slice(cursorPos);

    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPos - match[0].length;
    const mentionPrefix = (mentionType === "UserMention" || entityType === "CompanyMention") ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    const updatedText =
      textBeforeCursor.slice(0, startIndex) + mentionText + textAfterCursor;

    //  Set content state immediately (DON’T rely only on input.value)
    setContent(updatedText);

    const newCursorPosition = startIndex + mentionText.length;
    setCursorPosition(newCursorPosition); // React will move cursor on next render

    const safePostDynamicValues = Array.isArray(postDynamicValues) ? postDynamicValues : [];
    const dVno = safePostDynamicValues.length + 1;
    let newDynamicValue;

    if (mentionType === "UserMention" || mentionType === "CompanyMention") {
      newDynamicValue = {
        type: entityType || mentionType,
        dVno,
        entity: userUid, // userUid ya companyUid
        displayName,
      };

      console.log("newDynamicValue if", newDynamicValue);
    } else if (mentionType === "Hashtag") {
      newDynamicValue = {
        type: "Hashtag",
        dVno,
        entity: displayName, // naya ya existing hashtag text
        displayName,
      };
      console.log("newDynamicValue else", newDynamicValue);
    }
    // const updatedPostDynamicValues = [
    //   ...postDynamicValues,
    //   {
    //     type: entityType|| mentionType,
    //     dVno,
    //     entity: mentionType === "UserMention" ? userUid : suggestion,
    //     displayName,
    //   },
    // ];
    const updatedPostDynamicValues = [...safePostDynamicValues, newDynamicValue];
    setPostDynamicValues(updatedPostDynamicValues);

    console.log("updatedPostDynamicValues", updatedPostDynamicValues);
    // Replace mention text with placeholders
    let modifiedText = updatedText;
    updatedPostDynamicValues.forEach(({ type, dVno, display, displayName }) => {
      const prefix = (type === "UserMention" || type === "CompanyMention") ? "@" : "#";
      const fullMention = `${prefix}${displayName || display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    setPostInputValue(modifiedText.trim());
    setContent(updatedText); // Shows actual mention text (with @ or #) in input

    setShowSuggestions(false);
    setSearchText("");
  };

  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };
  // console.log('postList', postList);

  const regenerateReadableComment = (comment, dynamicValues) => {
    console.log("regenerateReadableComment", comment, dynamicValues);
    if (!comment || !dynamicValues?.length) return comment;

    let newComment = comment;

    dynamicValues.forEach((item) => {
      const placeholder = `{${item.dVno}}`;
      console.log("placeholder", item);
      let readable;

      //   if (item.type === "UserMention") {
      //     readable = `<a href="/user/${
      //       item.entityID || item.entity
      //     }" class="user-mention">@${item.displayName}</a>`;
      //   } else if (item.type === "Hashtag") {
      //     readable = `<a href="/hashtag/${item.displayName}" class="hashtag">#${item.displayName}</a>`;
      //   } else {
      //     readable = item.displayName;
      //   }
      if (item.type === "UserMention") {
        readable = `<a href="/user/${item.entityID || item.entity
          }" class="user-mention">@${item.displayName || item.display}</a>`;
      }
      else if (item.type === "CompanyMention") {
        readable = `<a href="/company/${item.entityID || item.entity}" class="user-mention">@${item.displayName || item.display}</a>`;
      }
      else if (item.type === "Hashtag") {
        readable = `<a href="/hashtag/${item.displayName || item.display
          }" class="hashtag">#${item.displayName || item.display}</a>`;
      } else {
        readable = item.displayName;
      }

      newComment = newComment.replaceAll(placeholder, readable);
    });

    return newComment;
  };

  const cancelEditHandler = () => {
    const updatedDynamicValue = oldDynamicValue;
    setEditedDynamicValue(updatedDynamicValue);
    const parsedComment = regenerateReadableComment(
      oldPostInputValue,
      oldDynamicValue
    );
    handleCommentChange(parsedComment, oldDynamicValue);
    setIsEditing(false);
  }

  const handleKeyDown1 = (e) => {
    if (showSuggestions) {
      const totalItems = mentionType === "Hashtag" ? suggestions.length + 1 : suggestions.length;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev + 1) % totalItems);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev - 1 + totalItems) % totalItems);
      } else if (e.key === "Enter") {
        e.preventDefault();

        if (mentionType === "Hashtag" && selectedIndex === 0) {
          insertMention(SearchText, null);
        } else {
          const itemIndex = mentionType === "Hashtag" ? selectedIndex - 1 : selectedIndex;
          const selectedItem = suggestions[itemIndex];
          if (selectedItem) {
            insertMention(
              (mentionType === "UserMention" || mentionType === "CompanyMention") ? selectedItem?.entityName : selectedItem?.hashTag,
              (mentionType === "UserMention" || mentionType === "CompanyMention") ? selectedItem?.userUid : null,
              selectedItem?.entityType,
            );
          }
        }

        setShowSuggestions(false);
        setSelectedIndex(0);
      } else if (e.key === "Escape") {
        setShowSuggestions(false);
      } else if (e.key === " ") {
        // Space pressed while suggestions open:
        // - For hashtag: commit manual typed hashtag (SearchText) as mention
        // - For mention: just close suggestions
        if (mentionType === "Hashtag") {
          e.preventDefault();
          if (SearchText && SearchText.trim()) {
            insertMention(SearchText.trim(), null);
          }
        }
        setShowSuggestions(false);
        setSelectedIndex(0);
      }
    } else {
      if (e.key === " ") {
        setShowSuggestions(false);
        setSelectedIndex(0);
      }
    }
  };

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [selectedIndex]);

  useEffect(() => {
    itemRefs.current = [];
    setSelectedIndex(0);
  }, [suggestions]);

  useEffect(() => {
    if (!showSuggestions) {
      setSelectedIndex(0);
    }
  }, [showSuggestions]);
  return (
    <>
      {isEditing ? (
        <div className="edit-comment" style={{ position: 'relative' }}>
          <input
            ref={editorRef}
            type="text"
            value={content} // Now editable
            onChange={handleChange}
            onKeyDown={handleKeyDown1}
            className="form-control"
          />
          {
            showSuggestions ?
              <ul
                ref={suggestionListRef}
                style={{
                  position: "absolute",
                  top: "30px", // adjust based on input position
                  left: "0",
                  zIndex: 10,
                  background: "#fff",
                  border: "1px solid #ccc",
                  width: "100%",
                  listStyle: "none",
                  padding: "0",
                  margin: "0",
                  maxHeight: "150px",
                  overflowY: "auto"
                }}>
                {mentionType === "Hashtag" ? <li
                  onMouseDown={(e) => {
                    e.preventDefault(); // Prevent editor blur
                    insertMention(
                      SearchText,
                      null
                    );
                  }}
                  className="suggestion-item"
                >
                  <span>{SearchText ? `#${SearchText}` : ''}</span>
                </li> : null}

                {suggestions.map((item, index) => {
                  const realIndex = mentionType === "Hashtag" ? index + 1 : index;
                  const isActive = selectedIndex === realIndex;
                  return (
                    <li
                      key={index}
                      ref={(el) => (itemRefs.current[realIndex] = el)}
                      onMouseDown={(e) => {
                        e.preventDefault(); // Prevent editor blur
                        insertMention(
                          mentionType === "UserMention" ? item?.entityName : item?.hashTag,
                          mentionType === "UserMention" ? item?.userUid : null,
                          item.entityType
                        );
                      }}
                      className={`suggestion-item ${isActive ? "active" : ""}`}
                    >
                      {mentionType === "UserMention" ? (
                        <>
                          <img
                            src={item?.avatar}
                            alt={item?.entityName}
                            className="avatar"
                          />
                          <span>{item?.entityName}</span>
                        </>
                      ) : (
                        <span>#{item?.hashTag}</span>
                      )}
                    </li>
                  )
                })}
              </ul> : null
          }
          <button disabled={saveDisabled} onClick={handleSaveComment} className="wljPrimaryBtn mt-2">
           {t("Newsfeed.Save")}
          </button>
          <button
            onClick={cancelEditHandler}
            className="wljSecondaryBtn ms-3 mt-2"
          >
            {t("Connections.Cancel")}
          </button>
        </div>
      ) : (
        <p className="f-14">{content}</p> // Show the final comment
      )}
    </>
  );
};

export default EditComment;
